import { useMutation, useQueryClient } from "@tanstack/react-query";
import { neWebApi } from "../../../../api";
import { neWebUrls, neWebQueryKeys } from "../../../../ne-web-urls";
import type { PPAInvoiceNumberRange } from "../PPAInvoiceNumberRangesPage.types";

interface CreateMutationData {
  newRange: Omit<PPAInvoiceNumberRange, "id" | "counter_reset_interval">;
}

export function useInvoiceNumberRangeMutations() {
  const queryClient = useQueryClient();

  const createMutation = useMutation({
    mutationFn: (data: CreateMutationData) =>
      createInvoiceNumberRange(data.newRange),
    onMutate: handleCreateOrEditMutate,
    onSettled: handleSettled
  });

  const deleteMutation = useMutation({
    mutationFn: (rangeId: string) => deleteInvoiceNumberRange(rangeId),
    onSettled: handleSettled
  });

  async function handleCreateOrEditMutate() {
    await queryClient.cancelQueries({
      queryKey: neWebQueryKeys.ppaInvoicing.invoiceNumberRanges()
    });
  }

  function handleSettled() {
    return queryClient.invalidateQueries({
      queryKey: neWebQueryKeys.ppaInvoicing.invoiceNumberRanges()
    });
  }

  return {
    createMutation,
    deleteMutation
  };
}

function createInvoiceNumberRange(
  newRange: Omit<PPAInvoiceNumberRange, "id" | "counter_reset_interval">
) {
  const url = neWebUrls.api.ppaInvoiceNumberRanges();
  return neWebApi.post<PPAInvoiceNumberRange>(url, newRange);
}

function deleteInvoiceNumberRange(rangeId: string) {
  const url = neWebUrls.api.ppaInvoiceNumberRange(rangeId);
  return neWebApi.delete(url);
}
